// src/pages/POS/posThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData, postData } from "../../apiservice/apis";
import {
  getAccountBySeachApi,
  getEmployeesApi,
  getWarehouseApi,
  getAccountByTypeApi
} from "../../apiservice/setting";
import {
  getItemBySearchApi,
  getSundryDebitorBalanceApi,
} from "../../apiservice/accounts";
import {
  getSalesVoucherApi,
  getCustomerSpecialPriceApi,
  getCurrentStockApi,
} from "../../apiservice/sales";
import { createPosPayload } from "../../utils/pos";

// ✅ Fetch POS Voucher Number
export const fetchPosVoucherNumber = createAsyncThunk(
  "pos/fetchVoucherNumber",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSalesVoucherApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch Customers
export const fetchCustomers = createAsyncThunk(
  "pos/fetchCustomers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({ type: "debitor", acc_type_name: ["Customer"] });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// ✅ Fetch Items
export const fetchItems = createAsyncThunk(
  "pos/fetchItems",
  async (partyType, { rejectWithValue }) => {
    try {
      const res = await getItemBySearchApi({ search: false, partyType });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch Sales Accounts
export const fetchSalesAccounts = createAsyncThunk(
  "pos/fetchSalesAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({ multiType: ["sale_account"] });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Create Sales (POS Entry)
export const createSales = createAsyncThunk(
  "pos/createSales",
  async ({ location }, { getState, rejectWithValue }) => {
    try {
      const state = getState().pos;  // ✅ pull everything from slice

      const payload = createPosPayload({
        itemCart: state.itemCart,
        customer: state.customer,
        footerValues: state.footerValues,
        voucherNumber: state.voucherNumber,
        taxMode: state.taxMode,
        payCart: state.payCart,
        entryDate: state.entryDate,
        selectedSalesAcc:state.selectedSalesAcc,
        selectedTaxAcc : state.selectedTaxAcc,
        selectedDiscountAcc : state.selectedDiscountAcc,
        selectedTransportAcc : state.selectedTransportAcc
      });

 
      let url = `/sales/create-sales`;
      if (location?.pathname?.includes("pos-update")) {
        url = `/sales/update-sales`;
      }
      const res = await postData(url, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCustomerSpecialPrice = createAsyncThunk(
  "pos/fetchCustomerSpecialPrice",
  async ({ customerId, itemId }, { rejectWithValue }) => {
    try {
      const res = await getCustomerSpecialPriceApi({
        customer_id: customerId,
        item_id: itemId,
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchItemStock = createAsyncThunk(
  "pos/fetchItemStock",
  async ({ itemId, branchId }, { rejectWithValue }) => {
    try {
      const res = await getCurrentStockApi({
        item_id: itemId,
        branch_id: branchId
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTaxAccounts = createAsyncThunk(
  "supplierPayments/fetchTaxAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "dutie_&_tax",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDiscountAccounts = createAsyncThunk(
  "supplierPayments/fetchDiscountAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_name: "discount on sale",
        acc_type_id: "direct_expense",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTransportAccounts = createAsyncThunk(
  "supplierPayments/fetchTransportAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "direct_income",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);